import _ from 'lodash'

export default {
  FormatNumber (valueNumber, max, precision) {
    if (valueNumber !== null && valueNumber !== '' && Number.isInteger(valueNumber)) {
      max = (max !== null && max !== '') ? max : 0
      precision = (precision !== null && precision !== '') ? precision : 0

      var tempNumber = valueNumber.toString().replace(',', '.')
      var valorNegativo = parseFloat(tempNumber) < 0
      if (valorNegativo) {
        tempNumber *= -1
      }
      var valorFinal = (parseFloat(tempNumber)).format(Array(max + 1).join('0') + '.' + Array(precision + 1).join('0'))
      valorFinal = this.FormatNumberToShow(valorFinal)
      if (valorNegativo) {
        valorFinal = '-'.concat(valorFinal)
      }
      return valorFinal
    } else {
      return ''
    }
  },
  FormatToShowDecimal (valueNumber) {
    if (valueNumber) {
      if (valueNumber !== null && valueNumber !== '' && Number.isInteger(valueNumber)) {
        var value = valueNumber + ''
        if (value.indexOf('.') > -1 || value.indexOf(',') > -1 || !this.IsInt(valueNumber) || this.IsFloat(valueNumber)) {
          var newStringNumber = this.FormataDecimais(valueNumber, 2)
          return newStringNumber
        }
      }
    }
    return valueNumber
  },
  FormatToSaveDecimal (valueNumber) {
    if (valueNumber) {
      if (valueNumber !== null && valueNumber !== '') {
        var value = valueNumber + ''
        value = value.replace(',', '.')
        var newNumber = value * 1
        return newNumber
      }
    }
    return valueNumber
  },
  ValidBrazilianNumber (valueNumber) {
    if (valueNumber && valueNumber !== null) {
      var value = valueNumber + ''
      return (/^\d+(,\d{0,2})?$/).test(value + '')
    }
    return false
  },
  ValidAmericanNumber (valueNumber) {
    if (valueNumber && valueNumber !== null) {
      var value = valueNumber + ''
      return (/^\d+(\.\d{0,2})?$/).test(value + '')
    }
    return false
  },
  FormataDecimais (iValor, iDecimais) {
    if (iValor !== '' && iValor !== null) {
      var sValor = String(iValor)
      sValor = sValor.replace('.', ',')
      var iLen = sValor.length - 1
      var iPosPonto = sValor.indexOf(',')
      var iInd = 0
      var iLenDecimais = 0
      if (iPosPonto > 0) {
        iLenDecimais = (iLen - iPosPonto)
        iInd = iLenDecimais
      } else {
        if (iDecimais > 0) {
          sValor = sValor.concat(',')
        }
        iInd = 0
      }
      while (iInd < iDecimais) {
        sValor = sValor.concat('0')
        iInd = iInd + 1
      }
      return sValor
    } else {
      return ''
    }
  },
  Left (str, n) {
    var retorno = ''
    if (n <= 0) {
      retorno = ''
    } else if (n > String(str).length) {
      retorno = str
    } else {
      retorno = String(str).substring(0, n)
    }
    return retorno
  },
  Right (str, n) {
    var retorno = ''
    if (n <= 0) {
      retorno = ''
    } else if (n > String(str).length) {
      retorno = str
    } else {
      var iLen = String(str).length
      retorno = String(str).substring(iLen, iLen - n)
    }
    return retorno
  },
  IsInt (n) {
    return Number(n) === n && n % 1 === 0
  },
  IsFloat (n) {
    return Number(n) === n && n % 1 !== 0
  },
  FormatCode: function (code) {
    var value = code.toString()
    var zero = '0'
    var result = ''

    for (var i = value.length; i < 6; i++) {
      result = result + zero
    }
    return result + value
  },
  MinimizedSidebar: function () {
    if (!document.body.classList.contains('sidebar-minimized')) {
      document.body.classList.toggle('sidebar-minimized')
    }
    document.body.classList.remove('sidebar-mobile-show')
    window.scrollTo(0, 0)
  },
  MinimizedASidebar: function () {
    document.body.classList.remove('aside-menu-fixed')
    if (!document.body.classList.contains('aside-menu-hidden')) {
      document.body.classList.add('aside-menu-hidden')
    }
    window.scrollTo(0, 0)
  },
  ValidateForms: function (forms, data, self, toast) {
    var result = true
    for (var opt in forms) {
      if (forms[opt]) {
        if (forms[opt].hasOwnProperty('required')) {
          if (forms[opt].required === true) {
            if (forms[opt].value === null || forms[opt].value === '' || forms[opt].value === undefined) {
              toast.warning(self.$lang.Common.Alerts.RequiredField)
              forms[opt].state = false
              setTimeout(function () {
                forms[opt].state = null
              }, 7000)
              return false
            }
          }
        }
      }
    }
    this.SetValueToSave(forms, data)

    return result
  },
  ClearDataForms: function (forms, data) {
    for (var opt in forms) {
      if (forms[opt].hasOwnProperty('value')) {
        if (forms[opt].hasOwnProperty('defaultArray')) {
          forms[opt].value = []
        } else if (forms[opt].hasOwnProperty('defaultValue')) {
          forms[opt].value = forms[opt].defaultValue
        } else {
          forms[opt].value = null
        }
      }

      if (forms[opt].hasOwnProperty('selected')) {
        forms[opt].selected = null
      }

      if (forms[opt].hasOwnProperty('clearOption')) {
        if (forms[opt].clearOption) {
          forms[opt].options = []
        }
      }
    }

    for (var property in data) {
      data[property] = null
    }
  },
  SetValueInForm: function (forms, data, obj) {
    let protectId = false
    for (var key in data) {
      if (obj[key] !== '00000000-0000-0000-0000-000000000000') {
        if (obj.hasOwnProperty(key)) {
          data[key] = obj[key]
          if ((this.ValidBrazilianNumber(obj[key]) || this.ValidAmericanNumber(obj[key])) && protectId) {
            data[key] = this.FormatToShowDecimal(obj[key])
            protectId = true
          }
        }
        if (forms.hasOwnProperty(key)) {
          if (forms[key].hasOwnProperty('value')) {
            forms[key].value = obj[key]
            if (this.ValidBrazilianNumber(obj[key]) || this.ValidAmericanNumber(obj[key])) {
              forms[key].value = this.FormatToShowDecimal(obj[key])
            }
          } else if (Object.keys(forms[key]).length !== 0) {
            for (var subkey in forms[key]) {
              if (forms[key][subkey].hasOwnProperty('value')) {
                forms[key][subkey].value = obj[key].length > 0 ? obj[key][0][subkey] : obj[key][subkey]
                if (this.ValidBrazilianNumber(obj[key][subkey]) || this.ValidAmericanNumber(obj[key][subkey])) {
                  forms[key][subkey].value = this.FormatToShowDecimal(obj[key][subkey])
                }
              }
            }
          }
        }
      }
    }
  },
  SetFormDefaultValues: function (form) {
    for (var key in form) {
      if (form[key].defaultValue !== null && form[key].defaultValue !== undefined) {
        form[key].value = form[key].defaultValue
      } else {
        form[key].value = undefined
      }
    }
  },
  SetValueToSave: function (forms, data) {
    for (var key in forms) {
      if (data.hasOwnProperty(key)) {
        if (forms[key].hasOwnProperty('defaultArray')) {
          var options = forms[key].options
          data[key] = []
          for (var i in options) {
            data[key].push(options[i].value)
          }
        } else {
          data[key] = forms[key].value
        }
      }
    }
  },
  IsValid: function (obj) {
    var result = false
    if (obj != null && obj !== '' && obj.length > 0) {
      this.result = true
    }
    return result
  },
  removeItemArray: function (array, value) {
    for (var i in array) {
      if (array[i].value === value) {
        array.splice(i, 1)
      }
    }
    return array
  },
  formatMoneyBR (value) {
    let val = (value / 1).toFixed(2).replace('.', ',')
    return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  },
  formatCpfCnpj (v, label) {
    // CNPJ
    if (label === 'PJ') {
      return this.formataCampo(v, '00.000.000/0000-00', event)
    }
    // CPF
    if (label === 'PF') {
      return this.formataCampo(v, '000.000.000-00', event)
    }
  },
  // formata de forma generica os campos
  formataCampo (campo, Mascara, evento) {
    var boleanoMascara

    var Digitato = evento.keyCode
    /* eslint-disable-next-line */
    var exp =  /\-|\.|\/|\(|\)| /g
    var campoSoNumeros = campo.toString().replace(exp, '')

    var posicaoCampo = 0
    var NovoValorCampo = ''
    var TamanhoMascara = campoSoNumeros.length

    if (Digitato !== 8) {
      for (var i = 0; i <= TamanhoMascara; i++) {
        boleanoMascara = ((Mascara.charAt(i) === '-') || (Mascara.charAt(i) === '.') || (Mascara.charAt(i) === '/'))
        boleanoMascara = boleanoMascara || ((Mascara.charAt(i) === '(') || (Mascara.charAt(i) === ')') || (Mascara.charAt(i) === ' '))
        if (boleanoMascara) {
          NovoValorCampo += Mascara.charAt(i)
          TamanhoMascara++
        } else {
          NovoValorCampo += campoSoNumeros.charAt(posicaoCampo)
          posicaoCampo++
        }
      }
      // campo.value = NovoValorCampo
      return NovoValorCampo
    } else {
      return NovoValorCampo
    }
  },
  s2ab (s) {
    var buf = new ArrayBuffer(s.length)
    var view = new Uint8Array(buf)
    for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
    return buf
  },
  toDateTime (secs) {
    var t = new Date(1970, 0, 1) // Epoch
    t.setSeconds(secs)
    return t
  },
  toFormatDateTime (dateStr) {
    let result = ''
    if (dateStr) {
      let dateArr = dateStr.split('T')
      let date = dateArr[0].split('-')
      let time = dateArr[1].substring(0, 8)
      result = date[2] + '/' + date[1] + '/' + date[0] + ' ' + time
    }
    return result
  },
  checkDocumentType (document) {
    let documentOnlyNumberLength = document ? document.replace(/[^\d]+/g, '').length : ''
    if (documentOnlyNumberLength === 14) {
      return 'PJ'
    } else if (documentOnlyNumberLength === 11) {
      return 'PF'
    }
    return null
  },
  getInitialsOfName (value) {
    let result = 'ND'
    let nome = value.replace(/\s+$/g, '')
    if (nome) {
      let opt = nome.split(' ')
      result = opt[0].slice(0, 1) + opt[opt.length - 1].slice(0, 1)
    }
    return result
  },
  abreviateWord (word) {
    if (word.split(' ').length !== 1) {
      // IF MORE THAN ONE WORD
      return this.getInitialsOfName(word)
    } else {
      if (word.length <= 6) return word
      else {
        return word.slice(0, 4) + '.'
      }
    }
  },
  getFilters (obj) {
    const res = []
    const keys = Object.keys(obj)
    keys.forEach(key => {
      if (obj[key]) {
        if (!Array.isArray(obj[key])) {
          let opt = `${key}=` + obj[key]
          res.push(opt)
        } else if (Array.isArray(obj[key]) && _.size(obj[key]) !== 0) {
          let opt = `${key}=` + obj[key]
          res.push(opt)
        }
      }
    })
    return res.join('&')
  },
  /**
   * Converts a long string of bytes into a readable format e.g KB, MB, GB, TB, YB
   *
   * @param {Int} num The number of bytes.
   */
  readableBytes (bytes) {
    var i = Math.floor(Math.log(bytes) / Math.log(1024))
    var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + sizes[i]
  },
  AuthorizeNotification () {
    // https://developer.mozilla.org/en-US/docs/Web/API/Notification
    // Let's check if the browser supports notifications
    if (!('Notification' in window)) {
      // alert('This browser does not support desktop notification')
    } else {
      Notification.requestPermission(function (perm) {
      })
    }
  },
  ShowNotification (title, message) {
    // Let's check if the browser supports notifications
    if (!('Notification' in window)) {
      // alert('This browser does not support desktop notification')
    } else {
      if (Notification.permission === 'granted') {
        var notification = new Notification(title, {
          dir: 'auto',
          lang: '',
          body: message,
          tag: 'Nexum' // ,
          // icon: process.env.BaseURL + 'static/img/avatars/01.png'
        })
        notification.onclick = () => {
          window.open(window.location.href)
        }
      } else {
        this.AuthorizeNotification()
      }
    }
  },
  /**
   * Downloads a Base64 encoded file
   * @param {String} base64Data - Base64 string of the file
   * @param {String} filename - Name of the file to download
   * @param {String} mimeType - MIME type (default: application/octet-stream)
   */
  downloadBase64File (base64Data, filename, mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    try {
      // Remove any data URL prefix if present
      const base64 = base64Data.replace(/^data:[^;]+;base64,/, '')

      // Convert base64 to binary
      const binaryString = window.atob(base64)
      const len = binaryString.length
      const bytes = new Uint8Array(len)

      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }

      // Create blob
      const blob = new Blob([bytes], { type: mimeType })

      // Create download link
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename

      // Trigger download
      document.body.appendChild(link)
      link.click()

      // Cleanup
      document.body.removeChild(link)
      window.URL.revokeObjectURL(link.href)
    } catch (error) {
      console.error('Erro ao fazer download do arquivo:', error)
      throw error
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/Tools.js